export default {
  DOWNLOAD: 'Download',
  PROCESSING: 'Processing',
  GENERAL_EVENT_INFO: 'General event info',
  EVENT_DETAILS: 'Event details',
  GENERATE_NEW: 'Generate new',
  REPORT_NOT_GENERATED: 'Your report has not been generated yet or no leads have been captured so far. Please try again after sometime.',
  REPORT_DOWNLOADED: 'Report downloaded successfully',
  DOWNLOAD_REPORT: 'Download report',
  LAST_GENERATED: 'Last report generated on',
  DOWNLOAD_REPORT_INFO: 'Generating a new report may take a moment, so please keep this tab open.'
}
